<template>
  <div>
    <div v-if="showTop" class="text-xs-center mb-2">
      <v-progress-linear v-if="loading" :indeterminate="true" :height="2"></v-progress-linear>
      <v-layout v-else align-center justify-space-between>
        <v-flex v-if="showRowsPerPage" shrink>
          <v-select
            :value="limit"
            :items="[10, 25, 50]"
            :label="$t('Rows per page')"
            hide-details
            class="ma-0"
            :style="{ width: '100%', maxWidth: '120px' }"
            @change="handleRowsPerPageChange"
          />
        </v-flex>
        <v-flex :shrink="showRowsPerPage">
          <v-pagination
            v-model="page"
            :length="pagelength"
            :total-visible="7"
            @input="changepage"
          ></v-pagination>
        </v-flex>
      </v-layout>
    </div>

    <slot></slot>

    <div v-if="showBottom" class="text-xs-center mt-2">
      <v-progress-linear v-if="loading" :indeterminate="true" :height="2"></v-progress-linear>
      <v-layout v-else align-center justify-space-between>
        <v-flex v-if="showRowsPerPage" shrink>
          <v-select
            :value="limit"
            :items="[10, 25, 50]"
            :label="$t('Rows per page')"
            hide-details
            class="ma-0"
            :style="{ width: '100%', maxWidth: '120px' }"
            @change="handleRowsPerPageChange"
          />
        </v-flex>
        <v-flex :shrink="showRowsPerPage">
          <v-pagination
            v-model="page"
            :length="pagelength"
            :total-visible="7"
            @input="changepage"
          ></v-pagination>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 10
    },
    loading: {
      type: Boolean,
      default: false
    },
    showTop: {
      type: Boolean,
      default: true
    },
    showBottom: {
      type: Boolean,
      default: true
    },
    showRowsPerPage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pagetmp: '',
      offset: 1,
      page: this.value
    }
  },
  computed: {
    pagelength() {
      if (this.total) {
        var total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  methods: {
    changepage(val) {
      this.$emit('input', this.page)
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        this.offset = this.page * this.limit - this.limit
        if (this.page != 1) {
          this.offset + 1
        }
        this.$emit('onChange', { limit: this.limit, offset: this.offset, page: val })
      }
    },
    handleRowsPerPageChange(val) {
      this.$emit('onChange', { limit: val, offset: 0, page: 1 })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/Pagination2.vue